import { type TextStyle, type ViewStyle } from 'react-native';

import { theme } from '@sg/garnish';

// ─── Palettes ────────────────────────────────────────────────────────────────

export const backgroundPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.CREAM,
  },
  'dark-kale': {
    backgroundColor: theme.colors.DARK_KALE,
  },
};

export const backgroundWithBorderPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  'dark-kale': {
    borderWidth: 1,
    borderColor: theme.colors.CREAM,
    backgroundColor: theme.colors.DARK_KALE,
  },
};

export const emptyStylePalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
  'dark-kale': {
    borderWidth: 1,
    borderColor: theme.colors.CREAM,
    backgroundColor: theme.colors.DARK_KALE,
  },
};

export const illustrationPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {},
  'dark-kale': {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.CREAM,
  },
};

export const titlePalettes: Record<ScanToPayPalette, TextStyle> = {
  cream: {
    color: theme.colors.KALE,
  },
  'dark-kale': {
    color: theme.colors.CREAM,
  },
};

export const textPalettes: Record<ScanToPayPalette, TextStyle> = {
  cream: {
    color: theme.colors.DARK_KALE,
  },
  'dark-kale': {
    color: theme.colors.CREAM,
  },
};

export const warningTextPalettes: Record<ScanToPayPalette, TextStyle> = {
  cream: {
    color: theme.colors.CAUTION,
  },
  'dark-kale': {
    color: theme.colors.CREAM,
  },
};

export const iconPalettes: Record<ScanToPayPalette, string> = {
  cream: theme.colors.DARK_KALE,
  'dark-kale': theme.colors.CREAM,
};

export const warningIconPalettes: Record<ScanToPayPalette, string> = {
  cream: theme.colors.CAUTION,
  'dark-kale': theme.colors.CREAM,
};

export const lightIconPalettes: Record<ScanToPayPalette, string> = {
  cream: theme.colors.KALE,
  'dark-kale': theme.colors.CREAM,
};

export const iconBackgroundPalettes: Record<ScanToPayPalette, ViewStyle> = {
  cream: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
  },
  'dark-kale': {
    backgroundColor: theme.colors.OPACITY.CREAM.DARK,
  },
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type ScanToPayPalette = 'cream' | 'dark-kale';
